export enum WEBHOOK_ACTIONS {
  SAVE_DETAILS = 'SAVE_DETAILS',
  SAVE_TYPE_INFO = 'SAVE_TYPE_INFO',
  SAVE_PAYLOAD = 'SAVE_PAYLOAD',
  GET_DETAILS = 'GET_DETAILS',
  VIEW_LOGS = 'VIEW_LOGS',
}
